class HideMessage{
  hideMessage() {
    setTimeout(function() {
      if (document.getElementById('fixed-error-div')) {
        document.getElementById('fixed-error-div').classList.add('fadeMsg');
      }
    }, 3100)

    setTimeout(function() {
      if(document.getElementById('fixed-error-div')){
        document.getElementById('fixed-error-div').innerHTML = '';
      }
      if (document.getElementsByClassName('fadeMsg')[0]) {
        document.getElementsByClassName('fadeMsg')[0].classList.remove('fadeMsg');
      }
    }, 3750)
  }

  displaySuccessMsg(msg) {
    if (document.getElementById('fixed-error-div')) {
      document.getElementById('fixed-error-div').innerHTML = ('<div class="alert alert-success alert-dismissible fade show" role="alert">'+
        '<button type="button" class="close" aria-label="Close" onClick="javascript:(document.getElementById(\'fixed-error-div\').innerHTML=\'\')">'+
          '<span aria-hidden="true">×</span></button>'+msg+'</div>')
          this.hideMessage()
    }
  }

  displayErrorMsg(error) {
    if (document.getElementById('fixed-error-div')) {
      document.getElementById('fixed-error-div').innerHTML = ('<div class="alert alert-danger alert-dismissible fade show" role="alert">'+
        '<button type="button" class="close" aria-label="Close" onClick="javascript:(document.getElementById(\'fixed-error-div\').innerHTML=\'\')">'+
          '<span aria-hidden="true">×</span></button>'+error+'</div>')
          this.hideMessage()
    }
  }
}

const hideMessage = new HideMessage()

export default hideMessage
